
import {
    defineComponent, computed, unref, ref,
} from '@vue/composition-api';
import { useActions, useState, useGetters } from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { IOperatorRepository } from '@ve/repositories/operator/types';
import namesRepository from '@ve/repositories/config';
import FilterListRender from '@ve/components/filters/common/components/FilterListRender/FilterListRender.vue';
import FilterPostWrapper from '@ve/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
import ToggleListContent from '@ve/components/filters/common/components/toggleListContent/ToggleListContent.vue';
import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import FilterAttributeMethodsOperators from './filterAttributeMethods/FilterAttributeMethodsOperators';

export default defineComponent({
    components: {
        FilterListRender,
        FilterPostWrapper,
        FiltersListSection,
        ToggleListContent,
    },
    setup() {
        const {
            syncHotels, operators, filteredHotelsWithoutOperator, isPopularityFilterActive,
        } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['syncHotels', 'operators', 'filteredHotelsWithoutOperator', 'isPopularityFilterActive']);

        const { action_operators: setOperatorsIds } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_operators']);

        const { getEntities: OperatorEntities } = useGetters<IOperatorRepository['getters']>(namesRepository.operatorRepositoryName, ['getEntities']);

        const operatorIds = computed({
            get: () => unref(operators),
            set: (values) => setOperatorsIds(values),
        });
        const filterAttributesMethods = computed(() => new FilterAttributeMethodsOperators(unref(OperatorEntities)));

        const isLeastOneHotelHasOperator = computed(() => !!unref(filterAttributesMethods)?.getIsOneHotelHasProperty(unref(syncHotels)));

        return {
            filterAttributesMethods,
            syncHotels,
            filteredHotelsWithoutOperator,
            operatorIds,
            isLeastOneHotelHasOperator,
            isPopularityFilterActive,
            ...useFilterAttributesAnalytics(unref(filterAttributesMethods), { typeEvent: '', nameAnyEventEng: '', nameAnyEventRu: 'туроператор_Любой' }),
        };
    },
});
